import { ExternalLink } from "../../ui/ExternalLink"
import type { ExternalLinkProps } from "../../ui/ExternalLink/ExternalLink"

interface IButton extends Omit<ExternalLinkProps, "to" | "href"> {
  href?: string
}
export const GetStartedButton = ({ ...buttonProps }: IButton): JSX.Element => {
  const signupUrl = `${process.env.GATSBY_BASE_URL}/how-can-we-help`

  const buttonTitle = buttonProps.text || "Get started"
  return (
    <ExternalLink
      {...buttonProps}
      href={buttonProps.href || signupUrl}
      text={buttonTitle}
      fontSize={14}
      paddingHorizontal={24}
      height={buttonProps.height || 56}
    />
  )
}
